<template>
		<BaseCmsLabel code="social" class="social" tag="div" />
</template>

<style scoped lang="less">
	.social{
		display: flex; height: 100%; border-left: 1px solid rgba(255,255,255,.25); margin-left: 25px;
		:deep(a){
			display: flex; color: #fff; text-decoration: none; align-items: center; justify-content: center; font-size: 0; aspect-ratio: 1; height: 100%; width: 48px; border-right: 1px solid rgba(255,255,255,.25); .transition(background);
			&:before{.icon-facebook(); font: 16px/1 var(--fonti); .transition(color);}
			&[href*=instagram]:before{.icon-instagram();}
			&[href*=pinterest]:before{.icon-pinterest();}
		}
	}
	.social2{
		gap: 8px; border: 0; margin: 0; padding-top: 16px; height: auto;
		:deep(a){
			background: var(--blue); border-radius: 10px; width: 44px; height: 44px; border: 0; .transition(background);
			&:hover{background: var(--blue2);}
		}
		@media (max-width: @m){justify-content: center;}
	}
	.header-social{
		@media (max-width: @l){margin-left: 8px;}
		@media (min-width: @h){
			:deep(a){
				&:hover{
					background: var(--blue2);
					&:before{color: #fff;}
				}
			}
		}
	}
</style>